import { on, reducer } from "ts-action";
import { withLoadingReducer } from "../../../Components/Pickup/redux-store/reducers/withLoadingState";
import { getLoyaltyGiftMenuAction } from "../../../constants";
import * as actions from "../../actions";
import { mapById } from "../../../hooks/use-cashiers";
import { GiftItem, LoyaltyMenuState } from "../../../types";
import { updateMenuItems } from "../../../helpers/gift-list/updateMenuItems";

const initialState: LoyaltyMenuState = {
  categoriesIds: [],
  shownCategoriesIds: [],
  shownCategoriesById: {},
  categoriesById: {},
  selectedCategoryId: "",
  search: "",
};

export default withLoadingReducer<LoyaltyMenuState>(
  reducer<LoyaltyMenuState>(
    [
      on(actions.getLoyaltyGiftMenuFailure, (state) => ({
        ...state,
        categoriesIds: [],
        shownCategoriesIds: [],
        categoriesById: {},
        shownCategoriesById: {},
      })),

      on(actions.getLoyaltyGiftMenuSuccess, (state, { payload }) => {
        const filteredMenu = payload.menu.map((category) => ({
          ...category,
          items: category.items.filter(
            (item) => !payload.excludedGiftItemIds.includes(item.id)
          ),
        }));

        const shownMenu = filteredMenu.filter(
          (category) => category.items.length > 0
        );
        return {
          ...state,
          categoriesIds: payload.menu.map((item) => item.id),
          shownCategoriesIds: shownMenu.map((item) => item.id),
          categoriesById: mapById(filteredMenu),
          shownCategoriesById: mapById(shownMenu),
        };
      }),

      on(actions.searchLoyaltyGiftMenuItems, (state, { payload }) => {
        const searchTerm = payload.search_term.trim().toLowerCase();

        if (!searchTerm) {
          const visibleCategories = Object.values(state.categoriesById).filter(
            (category) => category.items.length > 0
          );

          const shownCategoriesById = Object.fromEntries(
            visibleCategories.map((cat) => [cat.id, cat])
          );

          return {
            ...state,
            search: payload.search_term,
            shownCategoriesById,
            shownCategoriesIds: visibleCategories.map((cat) => cat.id),
          };
        }

        const shownCategoriesById: typeof state.shownCategoriesById = {};
        const shownCategoriesIds: string[] = [];

        for (const category of Object.values(state.categoriesById)) {
          const filteredItems: GiftItem[] = [];

          for (const item of category.items) {
            if (item.name?.toLowerCase().includes(searchTerm)) {
              filteredItems.push(item);
            }
          }

          if (filteredItems.length) {
            shownCategoriesById[category.id] = {
              ...category,
              items: filteredItems,
            };
            shownCategoriesIds.push(category.id);
          }
        }

        return {
          ...state,
          search: payload.search_term,
          shownCategoriesById,
          shownCategoriesIds,
        };
      }),
      on(actions.updateGiftGroupItems, (state, { payload }) => {
        const { item } = payload;
        return updateMenuItems(state, item);
      }),
      on(actions.removeMultiPosGiftGroupItem, (state, { payload }) => {
        const { item } = payload;
        if (!item.category_id || !item.id) return state;
        const category = state.categoriesById[item.category_id];
        const shownCategory = state.shownCategoriesById[item.category_id];

        const updatedShownCategory = {
          ...state.shownCategoriesById,
          [item.category_id]: {
            ...category,
            items: shownCategory ? [item, ...shownCategory.items] : [item],
          },
        };

        return {
          ...state,
          shownCategoriesById: updatedShownCategory,
          shownCategoriesIds: Object.keys(updatedShownCategory),
        };
      }),
      on(actions.updateGiftGroupItemsResult, (state, { payload }) => {
        const { item, success } = payload;
        if (!success) return state;
        return updateMenuItems(state, item);
      }),
      on(actions.removeGiftGroupItem, (state, { payload }) => {
        const { item, category_id } = payload;
        if (!category_id || !item.id) return state;
        const category = state.categoriesById[category_id];
        const shownCategory = state.shownCategoriesById[category_id];

        const shownCategoriesById = {
          ...state.shownCategoriesById,
          [category_id]: {
            id: category_id,
            name: category.name,
            items: shownCategory ? [...shownCategory.items, item] : [item],
          },
        };

        const shownCategoriesIds = state.shownCategoriesIds.includes(
          category_id
        )
          ? state.shownCategoriesIds
          : [...state.shownCategoriesIds, category_id];

        return {
          ...state,
          shownCategoriesById,
          shownCategoriesIds,
        };
      }),
    ],
    initialState
  ),
  getLoyaltyGiftMenuAction
);
